/**
 * Clerk renders the `<UserButton />` menu in its own portal, OUTSIDE
 * our Tailwind tree, so it doesn't inherit the app's dark mode (left
 * to itself the menu shows up white on the dark theme). This factory
 * returns a theme-matched `appearance` object keyed on the effective
 * theme — warm cream/coffee tokens, no `@clerk/themes` dependency.
 *
 * Extracted verbatim from the retired `Header.tsx` when the user
 * identity moved into the sidebar footer (`SidebarUtility`). Kept as a
 * standalone module so the single source of truth for the menu skin
 * isn't duplicated across surfaces.
 */

import type { EffectiveTheme } from "@/lib/theme";

export function clerkUserMenuAppearance(effective: EffectiveTheme) {
  return {
    variables:
      effective === "dark"
        ? {
            colorPrimary: "#d4a052",
            colorBackground: "#1a1714",
            colorText: "#f3eee3",
            colorTextSecondary: "rgba(243,238,227,0.65)",
            colorInputBackground: "#23201c",
            colorInputText: "#f3eee3",
            colorNeutral: "#f3eee3",
            fontFamily: "'DM Sans', system-ui, sans-serif",
            borderRadius: "8px",
          }
        : {
            colorPrimary: "#d4a052",
            colorBackground: "#ffffff",
            colorText: "#1a1714",
            colorTextSecondary: "rgba(26,23,20,0.6)",
            fontFamily: "'DM Sans', system-ui, sans-serif",
            borderRadius: "8px",
          },
  };
}
